import React, { useEffect, useState } from 'react';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import Typography from '@mui/material/Typography';
import InputLabel from '@mui/material/InputLabel';
import TextField from "@mui/material/TextField";
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { JsonTree } from '../../../../components/jsonEditorV2/jsontree/JsonTree';

const HTTP_METHODS = [
    { value: 'GET', label: 'GET' },
    { value: 'POST', label: 'POST' },
    { value: 'PUT', label: 'PUT' },
    { value: 'PATCH', label: 'PATCH' },
    { value: 'DELETE', label: 'DELETE'}
];


export const TriggerForm = ({ values = null, errorInputs = {}, onFieldsChange, t }) => {
    const [ formValues, setFormValues ] = useState(
        {
            type: '',
            subtype: '',
            method: 'GET',
            url: '',
            bodyData: {}
        }
    );

    useEffect(() => {
        if (values)
            setFormValues(values);
    }, [ values ])

    const handleChange = (event) => {
        const { name, value } = event.target;
        let js = { ...formValues, [ name ]: value };
        setFormValues(js);
        onFieldsChange([ js ]);
    };

    const handleChangeBD = (key, obj) => setFormValues({ ...formValues, [ key ]: obj });

    return (
        <Box>
            <Grid container spacing={ 2 } alignItems="center">
                <Grid size={ { xs: 10, sm: 10 } }>
                    <Typography variant='h6' component='h6'>
                        Trigger
                    </Typography>
                </Grid>
                <Grid size={ { xs: 12, sm: 6 } }>
                    <TextField fullWidth variant="outlined" size="small" label={ 'Type' } name={ 'type' }
                        value={ formValues.type }
                        onChange={ handleChange }
                        error={ Boolean(errorInputs.type?.isError) }
                        helperText={ errorInputs.type?.messageError || "" }
                    />
                </Grid>
                <Grid size={ { xs: 12, sm: 6 } }>
                    <TextField fullWidth variant="outlined" size="small" name={ 'subtype' } label={ 'Subtype' }
                        value={ formValues.subtype }
                        onChange={ handleChange }
                        error={ Boolean(errorInputs.subtype?.isError) }
                        helperText={ errorInputs.subtype?.messageError || "" }
                    />
                </Grid>
                <Grid size={ { xs: 12, sm: 6 } }>
                    <FormControl fullWidth required size="small"
                        error={ Boolean(errorInputs.method?.isError) }
                    >
                        <InputLabel id="method">Method</InputLabel>
                        <Select labelId="method" name="method" label="Method"
                            value={formValues.method}
                            onChange={handleChange}
                        >
                            {HTTP_METHODS.map(method => <MenuItem key={method.value} value={method.value} sx={{fontWeight: 600}}>{method.label}</MenuItem>)}
                        </Select>
                        {errorInputs.method?.isError && <FormHelperText>{errorInputs.method.messageError}</FormHelperText>}
                    </FormControl>
                </Grid>

                <Grid size={ { xs: 12, sm: 6 } }>
                    <TextField fullWidth variant="outlined" size="small" label={ 'Url' } name={ 'url' }
                        value={ formValues.url }
                        onChange={ handleChange }
                        error={ Boolean(errorInputs.url?.isError) }
                        helperText={ errorInputs.url?.messageError || "" }
                    />
                </Grid>
                <Grid size={ { xs: 12, sm: 6 } }>
                    <JsonTree keyParent={ 'bodyData' } contentJson={ formValues.bodyData } handleChange={ handleChangeBD } />
                </Grid>
            </Grid>
        </Box>
    );
};

